import o from"./logger.js";const r=(r,t)=>o.e("react-sdk",t,r),t=o=>{throw o};export{r as logErrorHandler,t as throwErrorHandler};
//# sourceMappingURL=commons.js.map
